<template>
  <div class="animate slideInRight col-12 py-4 animate__delay-2s">
    <div class="col-12 px-0 relative">
      <div class="d-md-flex justify-content-between col-12 px-0 mx-0 row">
        <h4 class="summary-heading mt-0  col-sm-12 col-lg-6 text-center text-lg-left px-0" v-if="!summaryShown">Your Progress</h4>
        <h4 class="summary-heading mt-0  col-12 text-center text-lg-left px-0" v-else>Your Details</h4>

        <div
          class="d-md-flex text-center text-lg-right justify-content-end flex-wrap col-sm-12 col-lg-6 px-0"
          v-if="
            !summaryShown &&
            totalCostOfInsurance !== null &&
            totalCostOfInsurance !== 0 &&
            !Number.isNaN(totalCostOfInsurance) &&
            !Number.isNaN(totalCostOfInsurance.toFixed(2))
          "
        >
          <p class="summary-price my-0">Lowest Total Cost of Cover</p>
          <p
            class="text-black my-0 w-100 animate zoomIn"
            style="font-size: 30px; font-weight: bold"
          >
            {{ "$" + totalCostOfInsurance.toFixed(2) }}
          </p>
          <p
            class="text-black my-0 w-100 viewMoreLink animate fadeIn"
            @click="summaryShown = !summaryShown"
            v-if="!showLoader"
          >
            View Details
          </p>
        </div>
        <div
          class="d-flex text-right justify-content-end flex-wrap"
          v-if="summaryShown"
        >
          <p class="summary-price my-0"></p>
          <p
            class="text-black my-0 w-100 animate zoomIn"
            style="font-size: 30px; font-weight: bold"
          ></p>
          <p
            class="text-black my-0 w-100 viewMoreLink"
            @click="summaryShown = !summaryShown"
            v-if="!showLoader"
          >
            Show Progress
          </p>
        </div>
      </div>
      <div
        class="custom-scroll overflow-y-auto"
        :style="windowWidth >= 700 ? {'height':windowHeight - 450+'px !important'} : ''"
        v-if="summaryShown"
      >
        <summary-form
          :data="fields"
          :messages="messages"
          :formComplete="formComplete"
          :windowHeight="windowHeight"
          @openRefer="openRefer"
        ></summary-form>
        <div
          v-if="showEndorsements"
          v-show="!calculating"
          data-color="red"
          style="min-height: 0px !important"
        >
          <div class="m-b-20 mt-2">
            <h4 class="text-center">Endorsements</h4>
            <hr style="border-color: #29abe1" />
            <ul class="p-b-30 pl-0" v-if="this.pendingOrder.endorsements">
              <li
                v-for="(endorsement, index) in this.pendingOrder.endorsements"
                :key="index"
              >
                {{ endorsement.description }}
                <a
                  @mouseover="infoMouseOver($event)"
                  @click="showEndorsementDetailsPopup(endorsement)"
                  ><span class="ti-info-alt endorsement-info"></span
                ></a>
              </li>
            </ul>
            <p class="text-center p-b-20 pl-0" v-else>No endorsements to display.</p>
          </div>
        </div>
        <div
          v-bind:class="canShowEndorsementDetailsModal ? 'show' : 'hide'"
          class="modal"
          tabindex="-1"
          role="dialog"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="resetModalEndorsement"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">
                  {{ modalEndorsement ? modalEndorsement.description : null }}
                </h4>
              </div>
              <div class="modal-body">
                <div
                  v-if="modalEndorsement"
                  v-html="modalEndorsement.details"
                ></div>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
      </div>
      <div
        class="custom-scroll overflow-y-auto"
        :style="windowWidth >= 700 ? {'height':windowHeight - 420+'px !important'} : ''"
        v-else-if="!summaryShown"
      >
        <div
          class="d-flex align-items-center summary-section"
          v-for="(message, index) in getStageMessages"
          :key="index"
          @click="scrollTo('message_' + message.id)"
        >
          <!-- <div class="lane1 relative">
						<div :style="message.question.data.stage_start !== undefined && message.question.data.stage_start ? 'opacity:100' : 'opacity:0'">
							<div class="rounded-circle bg-green mr-3 text-white d-flex justify-content-center items-align-center" style="height: 25px; width: 25px" > 
								{{ message.question.data.stage  }}
							</div>
						</div>
					</div>  -->
          <div class="lane2 relative">
            <span
              class="line2"
              v-show="getStageMessages.length - 1 !== index"
            ></span>
            <div
              class="rounded-circle bg-green text-white mr-3 d-flex justify-content-center align-items-center"
              style="height: 18px; width: 18px"
            >
              <i class="fas fa-check"></i>
            </div>
          </div>

          <div class="capitalise">
            {{
              message.question.data &&
              message.question.data.label &&
              message.question.data.label.length > 0
                ? message.question.data.label
                : "Selection"
            }}
          </div>
        </div>
      </div>
      <div
        class="row mx-0 px-0 relative col-12 text-center"
        v-if="this.pendingOrder && !showLoader"
      >
        <div class="d-flex justify-content-center px-2 col-sm-12 col-lg-10 mx-auto">
          <div
            class="col d-flex btn-switch align-items-center justify-content-center cursor-pointer"
            @click="switchToForm"
          >
            <i class="fas fa-sync-alt mr-4"></i>
            SWITCH TO FORM
          </div>
        </div>
      </div>
    </div>

    <div
      v-bind:class="canShowEndorsementDetailsModal ? 'show' : 'hide'"
      class="modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="resetModalEndorsement"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ modalEndorsement ? modalEndorsement.description : null }}
            </h4>
          </div>
          <div class="modal-body">
            <div
              v-if="modalEndorsement"
              v-html="modalEndorsement.details"
            ></div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
/**
 *  Import dependencies & event bus
 */
import store from "../../store";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { EventBus } from "../../event-bus";
import Cookies from "js-cookie";
import * as appConfigs from "../../configs";
import axios from "axios";
import queryString from "query-string";
import { includes } from "lodash";
import swal from "sweetalert";
import { SweetModal } from "sweet-modal-vue";

/**
 * Import local components
 */
import SummaryForm from "./SummaryForm.vue";

export default {
  props: [
    "messages",
    "summaryShown",
    "windowHeight",
    "windowWidth",
    "showLoader",
    "fields",
    "formComplete",
  ],
  store,
  components: {
    SummaryForm,
    SweetModal,
  },
  data() {
    return {
      modalEndorsement: null,
      email: "",
      referName: "",
      referError: "",
      referShow: true,
      processingEmailForm: false,
      animation: "calculating",
      userInformationExpanded: false,
      underwriters: [],
    };
  },
  mounted() {
    this.initializeReminderToken();
    this.dataLoad();

    if(this.pendingOrder && this.pendingOrder.endorsements && this.pendingOrder.endorsements.length == 0){
      this.$store.commit("showEndorsements", false);
    }
  },

  computed: {
    ...mapState({
      configs: (state) => state.configs,
      orderId: (state) => state.orderId, // 3026
      pendingOrder: (state) => state.pendingOrder,
      selectedOccupation: (state) => state.selectedOccupation,
      step: (state) => state.step,
      prevStep: (state) => state.prevStep,
      unavailableOccupations: (state) => state.unavailableOccupations,
      accidentCover: (state) => state.accidentCover,
      agreedToTerms: (state) => state.agreedToTerms,
      calculating: (state) => state.calculating,
      customerEmail: (state) => state.customerEmail,
      existingPendingOrder: (state) => state.existingPendingOrder,
      quoteRejected: (state) => state.quoteRejected,
      showEmailBlock: (state) => state.showEmailBlock,
      showEndorsements: (state) => state.showEndorsements,
      stateByPostcode: (state) => state.stateByPostcode,
      summaryData: (state) => state.summaryData,
      underwriter: (state) => state.underwriter,
      usingCreditCard: (state) => state.usingCreditCard,
    }),
    ...mapGetters([
      "isExemptFromStampDuty",
      "totalCostOfInsurance",
      "cheapestCostUnderwriterName",
    ]),

    getStageMessages() {
      var messages = this.messages;
      messages = this.messages.filter((item) => {
        return (
          item.question !== undefined &&
          item.question !== null &&
          item.question.data !== undefined &&
          item.question.data.stage !== undefined &&
          item.question.data.stage !== null
        );
      });
      return messages;
    },
    canShowEndorsementDetailsModal() {
      return (
        this.modalEndorsement !== null && this.modalEndorsement.length !== 0
      );
    },
    fsgPdfUrl() {
      return appConfigs.fsgPdfUrl;
    },
    checkRefer() {
      if (this.referShow && isEmpty(this.pendingOrder.discount)) {
        return true;
      }

      return false;
    },
    cheapUnderwriter() {
      let min = null;
      for (let i = 0; i < this.underwriters.length; i++) {
        const item = this.underwriters[i];
        if (!item.summary) {
          continue;
        }
        if (!min || item.summary.totalPrice < min.summary.totalPrice) {
          min = item;
        }
      }
      return min;
    },
    dutyOfDisclosureUrl() {
      return appConfigs.dutyOfDisclosureUrl;
    },
    termsAndConditionsUrl() {
      return appConfigs.termsAndConditionsUrl;
    },
    bannerUrl() {
      return appConfigs.bannerUrl;
    },
    eFundInterestRate() {
      return appConfigs.eFundInterestRate;
    },
    adjustedTotal() {
      if (isEmpty(this.summaryData)) {
        return 0;
      }

      let total = this.summaryData.totalPrice || 0;

      if (this.accidentCover) {
        total += parseFloat(this.accidentCover.price);
      }
      return (total * this.eFundInterestRate).toFixed(2);
    },
    monthlyPayments() {
      if (
        isEmpty(this.pendingOrder) ||
        this.pendingOrder.period_of_cover != 12
      ) {
        return "Not Available";
      }
      let monthlyPayments = (this.adjustedTotal / 10).toFixed(2);
      return `$${monthlyPayments}`;
    },
    showSidebar() {
      return this.step >= 5;
    },

    showInReferral() {
      return (
        Cookies.get("convertFromReferral") != this.pendingOrder.id &&
        this.pendingOrder.in_referral
      );
    },

    showUnavailableOccupation() {
      if (
        this.step >= 3 &&
        this.prevStep >= 2 &&
        (includes(
          this.unavailableOccupations,
          this.pendingOrder.occupation_id
        ) ||
          this.pendingOrder.current_annual_revenue > 2500000 ||
          this.pendingOrder.status == "HS")
      ) {
        // Cleaning the pendingOrderId because
        // after the thank you page, user should be able to fill out the form again
        Cookies.remove("pendingOrderId");
        return true;
      }

      return false;
    },

    getFormFields() {
      var messages = this.messages;
      messages.forEach((item, index) => {
        item.id = index;
        if (item.type === "user") {
          item.question = messages[index - 1].questions ?? null;
        }
      });

      messages = messages.filter((item) => {
        return item.question !== undefined && item.question !== null;
      });
      return messages;
    },
    pendingOrderInfo() {
      if (isEmpty(this.pendingOrder)) {
        return null;
      }

      const fields = {
        name: { bold: true },
        occupation_id: {},
        business_name: {},
        phone: {},
        email: {},
      };

      const info = Object.keys(fields).reduce((out, item) => {
        if (this.pendingOrder.hasOwnProperty(item)) {
          out[item] = {
            ...fields[item],
            value: this.pendingOrder[item],
          };
        }
        return out;
      }, {});

      const occupation =
        info.occupation_id &&
        this.configs.occupations &&
        this.configs.occupations.filter(
          (item) => item.id == info.occupation_id.value
        )[0];
      if (occupation) {
        info.occupation_id.value = occupation.business_activity;
      }

      return info;
    },
  },
  watch: {
    underwriters(data) {
      if (
        this.fields.underwriter_id &&
        !data.some(
          (underwriter) =>
            !underwriter.disabled &&
            underwriter.id == this.fields.underwriter_id
        )
      ) {
        this.fields.underwriter_id = "";
      }
    },
    cheapUnderwriter(data) {
      if (data && !this.fields.underwriter_id) {
        this.fields.underwriter_id = data.id;
      }
    },
  },

  methods: {
    ...mapMutations({
      toggleEndorsements: "toggleShowEndorsements",
    }),
    ...mapActions({
      scrollToTop: "scrollToTop",
      loadPendingOrder: "loadPendingOrder",
      loadUnderwriters: "loadUnderwriters",
      calculate: "calculate",
    }),
    //check if reminder token exists, if it is then need to fire an ajax request to
    //check if the token is valid, then set the cookie, otherwise no further action
    //needed to be taken
    initializeReminderToken() {
      let vm = this;
      let queryStringObj = queryString.parse(location.search);
      if ("reminder_token" in queryStringObj) {
        //if any error/exception occur, do not need to do anything, so axios do not need
        //catch to handle error
        axios
          .get(appConfigs.decryptReminderTokenUrl, {
            params: queryStringObj,
          })
          .then((response) => {
            if (response.data.status == "error") {
              Cookies.remove("pendingOrderId");
              vm.$store.commit("setError", { error: response.data.message });
            } else if (response.data.status == "success") {
              Cookies.set("pendingOrderId", response.data.pending_order_id);
            }
          })
          .catch((error) => {
            Cookies.remove("pendingOrderId");
            vm.$store.commit("setError", { error: "Invalid token error" });
          });
      }
    },
    formatCurrency(value) {
      var parts = value.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      value = "$" + parts.join(".");
      return value;
    },
    scrollTo(ref) {
      this.$emit("scrollTo", ref);
    },
    switchToForm() {
      var message =
        "The responses you provided aren't saved, therefore you will loose the quote progress.";

      if (
        this.pendingOrder &&
        this.pendingOrder.id !== undefined &&
        this.pendingOrder.id !== null
      ) {
        message =
          "You will be transferred to the Quote Form, and you can proceed with the last saved step.";
      }
      swal({
        icon: "info",
        title: "Are you sure?",
        text: message,
        buttons: {
          cancel: {
            text: "Cancel",
            value: null,
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Confirm",
            value: true,
            closeModal: true,
          },
        },
      }).then((value) => {
        if (value) {
          this.$emit("switchToForm");
        }
      });
    },

    getUnderwriters() {
      const formData = Object.keys(this.form).reduce(
        (out, item) => ({
          ...out,
          [item]: {
            ...this.fields,
            ...this.form[item],
          },
        }),
        {}
      );

      return this.loadUnderwriters(formData);
    },
    dataLoad() {
      if (!this.pendingOrder) {
        return;
      }

      this.loadPendingOrder({
        orderId: this.pendingOrder.id,
      })
        .then((fields) => {
          this.fields = fields;
          this.form = Object.keys(this.form).reduce((out, item) => {
            const formFields = Object.keys(
              item == "brooklyn" || item == "ensurance"
                ? omit(this.form[item], ["period_of_cover", "deductible"])
                : this.form[item]
            );
            out[item] = {
              ...this.form[item],
              ...pick(fields, formFields),
            };
            return out;
          }, {});

          return this.getUnderwriters().then((underwriters) => {
            this.underwriters = underwriters;
          });
        })
        .catch(() => {});
    },
    showEndorsementDetailsPopup(endorsement) {
      this.modalEndorsement = endorsement;
    },
    resetModalEndorsement() {
      this.modalEndorsement = null;
    },
    infoMouseOver(event) {
      $(event.target).css("cursor", "pointer");
    },
    // used the old calculate price function
    calculatePrice: async function () {
      this.$store.commit("setCalculating", { calculating: true });

      await this.calculate(this.fields)
        .then((data) => {
          this.$store.commit("setSummaryData", { summaryData: data });

          this.$store.commit("clearError");
          if (this.pendingOrderId) {
            this.$store.commit("setCalculating", { calculating: false });
          }
          this.finishedCalculating = true;
          this.formLoading = false;
        })
        .catch((error) => {
          this.$store.commit("setCalculating", { calculating: false });
          if (error.response?.data.rejectQuote) {
            this.$store.commit("setQuoteRejected", { quoteRejected: true });
          }
          this.$store.commit("setSummaryData", { summaryData: false });
          const errorMessage = generateErrorMessage(error);
          this.$store.commit("setError", { error: errorMessage });
        });
    },
    openRefer() {
      this.$refs.referModal.open();
    },

    submitRefer() {
      let data = {
        email: this.email,
        name: this.referName,
      };

      this.loading = true;
      this.$store.commit("setScreenLoader", { showScreenLoader: true });

      axios
        .post(`${apiDomain}form/refer-friend/${this.pendingOrder.id}`, data)
        .then((res) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });

          if (res.status === 200) {
            const pendingOrder = res.data.data;
            this.$store.commit("setPendingOrder", { pendingOrder });

            const discount = parseFloat(pendingOrder.discount).toFixed(2);
            this.summaryData.totalPrice =
              this.summaryData.totalPrice - discount;
            this.summaryData.discount = parseFloat(
              pendingOrder.discount
            ).toFixed(2);
            const summaryData = this.summaryData;

            this.$store.commit("setSummaryData", { summaryData });

            this.referShow = false;
            this.$refs.referModal.close();
          }
        })
        .catch((err) => {
          this.$store.commit("setScreenLoader", { showScreenLoader: false });
          if (err) {
            this.referError = err;
          }
        });
    },
  },
};
</script>

<style lang="scss">
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.message_user {
  padding: 10px;
}
.summary-heading {
  color: #ccc;
  text-transform: uppercase;
}
.summary-price {
  color: #ccc;
  text-transform: uppercase;
  font-size: 12px;
}
.viewMoreLink {
  font-size: 12px !important;
  color: #1e98e0;
  cursor: pointer;
  margin-top: -10px !important;
  &:hover {
    color: #009245;
  }
}
.capitalise {
  text-transform: capitalize;
}
.text-blue {
  color: #1e98e0;
}
.bg-blue {
  background-color: #1e98e0;
}
.bg-green {
  background-color: #009245;
}
.relative {
  position: relative;
}
.btn-switch {
  border: 1px solid #1e98e0;
  color: #1e98e0;
  background-color: #fff;
  height: 50px;
  font-size: 16px;
  &:hover {
    border: 1px solid #009245;
    color: #009245;
  }
}
.btn-blue {
  background-color: #1e98e0;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  border: 1px solid #1e98e0;

  &:hover {
    background-color: #009245 !important;
    border: 1px solid #009245 !important;
  }
}
.bg-green {
  background-color: #009245;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  border: 1px solid #009245;

  &:hover {
    background-color: #1e98e0 !important;
    border: 1px solid #1e98e0 !important;
  }
}
.summary-section {
  margin-bottom: 5px;
  cursor: pointer;
  position: relative;
  .line1 {
    position: absolute;
    left: 10px;
    top: 25px;
    bottom: 0px;
    width: 5px;
    height: 50%;
    background-color: #009245;
  }
  .line2 {
    position: absolute;
    left: 8px;
    top: 15px;
    bottom: 0px;
    width: 3px;
    height: 100%;
    background-color: #009245;
  }
  &:hover {
    .bg-blue {
      background-color: #009245 !important;
    }
    color: #009245 !important;
  }
}
.blue-line {
  background-color: #1e98e0;
  border-radius: 10px;
  height: 8px;
}
.green-line {
  background-color: #009245;
  border-radius: 10px;
  height: 8px;
}
.message-box_user {
  border: 2px solid #bce4f9;
  background-color: #bce4f9;
  padding: 10px;
  color: #000;
  margin-top: 3px;
  border-radius: 15px 0px 15px 15px;
  width: fit-content;
  max-width: 60%;
  text-align: right;
  font-size: 16px;
  line-height: 26px;
}
@media screen and (max-width: 768px) {
  .message_user {
    padding: 5px !important;
    max-width: 100%;
  }
  .message-box_user {
    max-width: 100%;
  }
}

@media screen and (max-width: 1188px) {
  .summary-heading {
    font-size: 1.2em !important;
  }
 .btn-switch {
  height: 50px;
  font-size: 14px;
  }
}
.overflow-y-auto{
  overflow-y: auto !important;
}

</style>
    